import { Navigate, useLocation, useParams } from 'react-router';
import { detectLocale, readStoredLocale } from '@/i18n/locales';

/**
 * Short share links `/i/<code>` and `/a/<id>` (QR codes, messengers) → `/<lang>/i|a/<…>` keeping `?c=`.
 * Language: saved choice → browser languages → en (as RootRedirect).
 */
export function ShortLink({ kind }: { kind: 'a' | 'i' }) {
  const { code, id } = useParams();
  const { search } = useLocation();
  const lang = readStoredLocale() ?? detectLocale(typeof navigator !== 'undefined' ? navigator.languages : []);
  return <Navigate to={`/${lang}/${kind}/${encodeURIComponent((kind === 'i' ? code : id) ?? '')}${search}`} replace />;
}
